import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_MODEL_ENDPOINT, // 👈 your FastAPI backend URL
  withCredentials: true,            // 👈 allow sending/receiving cookies
});

export default api;
